import * as React from "react"

type ToastProps = {
    title?: string
    description?: string
    duration?: number
    variant?: "default" | "destructive"
}

export function useToast() {
    const toast = ({ title, description, duration = 3000, variant = "default" }: ToastProps) => {
        // Simple toast implementation using native browser APIs
        // You can replace this with a more sophisticated toast library if needed
        console.log(`Toast: ${title}${description ? ` - ${description}` : ''}`)

        // For now, we'll use a simple alert-style notification
        // In production, you'd want to use a proper toast component
        if (typeof window !== 'undefined') {
            const toastEl = document.createElement('div')
            const bgClass = variant === 'destructive' ? 'bg-red-600' : 'bg-gray-900'
            toastEl.className = `fixed bottom-4 right-4 ${bgClass} text-white px-4 py-3 rounded-lg shadow-lg z-50 animate-in slide-in-from-bottom-5`
            toastEl.innerHTML = `
        ${title ? `<div class="font-medium">${title}</div>` : ''}
        ${description ? `<div class="text-sm text-white/90 mt-1">${description}</div>` : ''}
      `
            document.body.appendChild(toastEl)

            setTimeout(() => {
                toastEl.classList.add('animate-out', 'slide-out-to-bottom-5')
                setTimeout(() => {
                    document.body.removeChild(toastEl)
                }, 200)
            }, duration)
        }
    }

    return { toast }
}
